/* eslint-disable */
import store from '@/store/index'
import Vue from 'vue'
import MainService from '@/services/MainService'

class Questionnary {
  questionnary:any
  parentLocation:any = {}

  constructor () {
    this.parentLocation = store.state.parentLocation
  }

  setMainQuestionnary () {
    store.state.questionnary.item = this.questionnary.item
    store.state.questionnary.geoip = this.questionnary.geoip
  }

  getMainQuestionnaryError (data:any) {
    store.state.questionnary.loading = false
  }

  getMainQuestionnarySuccess (data:any) {
    this.questionnary = data
    this.setMainQuestionnary()
    store.state.questionnary.loading = false
  }

  getMainQuestionnaryFinalSuccess (data:any) {
    this.questionnary =  {
      item: data.questionnary,
      geoip: data.geoip ? data.geoip : store.state.questionnary.geoip
    }
    this.setMainQuestionnary()
    store.state.questionnary.loading = false
  }

  storeSessionAnswers(sessionAnswers: any) {
    const data = {
      route: 'ocular/widget/session-answers',
      params: {
        sessionAnswers,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    }

    return MainService.post(data)
  }

  updateSessionAnswers (questionnaireCode: string, sessionAnswers: any) {
    const data = {
      route: `ocular/widget/session-answers/${questionnaireCode}`,
      params: {
        sessionAnswers,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    }

    return MainService.put(data)
  }

  getMainQuestionnary (questionnaryTypeId: any) {
    store.state.questionnary.loading = true

    const data: any = {
      route: `ocular/widget/questionnary`,
      method: 'GET',
      params: {
        questionnary_type_id: questionnaryTypeId
      },
      successHandler: questionnaryTypeId === 1 ? 'questionnary.getMainQuestionnarySuccess' : 'questionnary.getMainQuestionnaryFinalSuccess',
      errorHandler: 'questionnary.getMainQuestionnaryError',
    }

    try {
      const parentLocation:any = store.state.parentLocation
      if (parentLocation) {
        let currentLocation = `${parentLocation.origin}${parentLocation.pathname}`
        currentLocation = Vue.prototype.$widget.endsWith(currentLocation, '/') ? currentLocation : `${currentLocation}/`
        data.params.url = currentLocation
      }
    } catch (error) {
      console.log('getWidget ERROR', error)
    }

    if (questionnaryTypeId === 1) {
      window.parent.postMessage(`questionnary.getMainQuestionnary(${JSON.stringify(data)})`, '*')
    } else {
      window.parent.postMessage(`mainService.apiRequest(${JSON.stringify(data)})`, '*')
    }
  }
}

Vue.prototype.$questionnary = new Questionnary()
const questionnary = <any> new Questionnary()
export default new Questionnary()

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    questionnary[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);
